// lib/admin/adminAuth.ts

import { googleSignOut } from "@/lib/authGoogle";
import { auth, db } from "@/lib/firebase";
import { doc, getDoc } from "firebase/firestore";

export type AdminCheckResult = {
  isAdmin: boolean;
  uid: string | null;
  email: string | null;
  role?: string | null;
  reason?: string;
};

export async function checkCurrentUserIsAdmin(): Promise<AdminCheckResult> {
  const user = auth.currentUser;

  if (!user) {
    return {
      isAdmin: false,
      uid: null,
      email: null,
      reason: "No Firebase user is signed in.",
    };
  }

  const userRef = doc(db, "users", user.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    return {
      isAdmin: false,
      uid: user.uid,
      email: user.email ?? null,
      reason: `No users/${user.uid} document exists in Firestore.`,
    };
  }

  const data = userSnap.data();
  const role = typeof data.role === "string" ? data.role : null;

  if (role !== "admin") {
    return {
      isAdmin: false,
      uid: user.uid,
      email: user.email ?? null,
      role,
      reason: `This account is not admin. Current role: ${
        role ?? "missing"
      }.`,
    };
  }

  return {
    isAdmin: true,
    uid: user.uid,
    email: user.email ?? null,
    role,
  };
}

export async function signOutAdminOrWrongUser() {
  await googleSignOut();
}
